import styled from 'styled-components';

export const StyledTotalContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.6rem;
  border-radius: 0.6rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.text.main};
  width: fit-content;
  height: 5rem;
`;

export const StyledTotalWrapper = styled.div`
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;
